var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSumEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C63BABCA-ED3E-4DB7-A87A-E07DF6449E4D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "special",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tools",
    transform: "translate(-675.000000, -278.000000)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(645.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sum_edit",
    transform: "translate(30.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,18 L5.25,20.25 L5.25,15.75 L2.25,15.75 C1.422,15.75 0.75,15.078 0.75,14.25 L0.75,2.25 C0.75,1.422 1.422,0.75 2.25,0.75 L18.75,0.75 C19.578,0.75 20.25,1.422 20.25,2.25 L20.25,6.75",
    id: "Path",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 5.25,
    x2: 15.75,
    y2: 5.25,
    id: "Path",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 9.75,
    x2: 8.25,
    y2: 9.75,
    id: "Path",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#3DC1D3",
    points: "23.25 18.75 20.25 18.75 20.25 23.25 15.75 18.75 11.25 18.75 11.25 9.75 23.25 9.75"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.25,
    y1: 12.75,
    x2: 14.25,
    y2: 12.75,
    id: "Path",
    stroke: "#3DC1D3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.25,
    y1: 15.75,
    x2: 14.25,
    y2: 15.75,
    id: "Path",
    stroke: "#3DC1D3"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumEdit);
export default __webpack_public_path__ + "static/media/sum-edit.34ca3a599559f53e24ae74cdc7f6dee4.svg";
export { ForwardRef as ReactComponent };